export class UploadErrorData {
    isDisplaySelectionfacility:boolean
    isDisplaySelectionSurgeon:boolean
    isDisplaySelectionApplication:boolean;
    isUploadFailed:boolean;
    displaySelectionApplication:string;

}